import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, Link } from 'lucide-react';
import { toast } from 'sonner';

const ExtractUrlsTool = () => {
  const [input, setInput] = useState('');
  const [unique, setUnique] = useState(true);

  const extractUrls = () => {
    if (!input) return [];
    const urlRegex = /(https?:\/\/[^\s<>"{}|\\^`[\]]+)|(www\.[^\s<>"{}|\\^`[\]]+)/gi;
    const matches = input.match(urlRegex) || [];
    const cleaned = matches.map(url => url.startsWith('www.') ? 'https://' + url : url);
    return unique ? [...new Set(cleaned)] : cleaned;
  };

  const urls = extractUrls();
  const output = urls.join('\n');

  const copyUrls = () => {
    navigator.clipboard.writeText(output);
    toast.success(`${urls.length} URL(s) copied!`);
  };

  return (
    <div className="space-y-6" data-testid="extract-urls-tool">
      <div className="flex gap-4">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={unique}
            onChange={(e) => setUnique(e.target.checked)}
            className="rounded"
          />
          <span className="text-sm">Remove Duplicates</span>
        </label>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            Input Text
          </label>
          <Textarea
            placeholder="Paste text containing URLs..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block flex items-center gap-2">
            <Link className="w-4 h-4 text-primary" />
            Extracted URLs ({urls.length})
          </label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[250px] font-mono text-sm bg-muted/50"
            placeholder="Extracted URLs will appear here..."
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyUrls} disabled={urls.length === 0}>
          <Copy className="w-4 h-4 mr-2" /> Copy URLs
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default ExtractUrlsTool;
